module.exports = __webpack_public_path__ + "static/media/class1.6e98631b.svg";